import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Newspaper, ArrowLeft, FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OnboardingFlow } from "@/components/OnboardingFlow";

// Sandbox replica of the user onboarding. Fully simulated: nothing is persisted.
export default function AdminTest() {
  const navigate = useNavigate();

  const onComplete = async (domains, frequency) => {
    // Simulate the bulk-add delay for realism; persist nothing.
    await new Promise((r) => setTimeout(r, 700));
    const labels = { daily: "diario", twice_week: "dos veces/semana", weekly: "semanal", off: "sin correos" };
    toast.success(`¡Fin del tutorial! ${domains.length} medio(s), frecuencia: ${labels[frequency] || frequency}. (Prueba: no se guardó nada.)`);
  };

  return (
    <div className="min-h-screen bg-background" data-testid="admin-test">
      <div className="bg-amber-400 text-amber-950 text-center text-xs font-bold uppercase tracking-widest py-2 px-4 flex items-center justify-center gap-2" data-testid="test-sandbox-banner">
        <FlaskConical className="w-4 h-4" /> Modo prueba · No se guarda nada
      </div>

      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-primary flex items-center justify-center">
              <Newspaper className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading text-lg font-black tracking-tight">NEWS DIGEST</span>
          </div>
          <Button
            data-testid="admin-back-button"
            variant="outline"
            onClick={() => navigate("/admin")}
            className="rounded-none border-border h-10 gap-2"
          >
            <ArrowLeft className="w-4 h-4" /> Salir de la prueba
          </Button>
        </div>
      </header>

      <OnboardingFlow username="nuevo usuario" onComplete={onComplete} />
    </div>
  );
}
